import { useCallback } from 'react'
import ApiService from '../../services/ApiService'
import { showAlert } from '../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorReturnRequest = () => {
  const { t } = useTranslation()
  const returnRequest = useCallback(
    (payload) => {
      const uid_transaction = payload?.uid_transaction
      ApiService.jsonRequest('/fund-bill/update-retur', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t('response_message.send_success'),
            timer: 2000,
            redirect: `/order/view/${uid_transaction}`,
          })
        } else {
          showAlert({
            icon: 'warning',
            message: t(`response_message.${response?.messages}`),
            timer: 2000,
            reload: true,
          })
        }
      })
    },
    [t],
  )
  return { returnRequest }
}

export default InteractorReturnRequest
